export default "__VITE_ASSET__Ce_knv8W__"